import styles from "./buttons.module.css";

const SecondaryButton = ({ text, onClick, className = "", disabled = false }) => {
	return (
		<button 
			className={`${styles.SecondaryButton} ${className}`} 
			onClick={onClick}
			disabled={disabled}
		>
			{text}
		</button>
	);
};

export default SecondaryButton;
